module.exports = __webpack_public_path__ + "img/type_empty.60a55022.svg";